import OrganicLandingPage from "./OrganicLandingPage";
export default OrganicLandingPage;
